import {isNullOrEmpty} from './HelperUtils';
import {OWNER_KEYWORD, ROLE_PREFIX, SCOPE_PREFIX} from '../init/constants';
import {dynamicConfig} from '../init/config';

export const createRoleName = (roleName: string | null): string => {
    if (isNullOrEmpty(roleName)) {
        return '';
    }

    if (roleName) {
        roleName = roleName.trim().toUpperCase()
        if ((roleName.startsWith(ROLE_PREFIX)) || (roleName.startsWith(SCOPE_PREFIX))) {
            return roleName;
        }

        return ROLE_PREFIX + roleName;
    }

    return '';
};

export const getRoleNames = (roles: string[]): string[] => {
    if ((roles !== undefined) && roles && (roles.length > 0)) {
        return roles.filter(role => (!isNullOrEmpty(role)))
            .map(role => createRoleName(role));
    }

    return [];
};

export const getOwnerRoles = (roles?: string[]): string[] => {
    if ((roles !== undefined) && roles && (roles.length > 0)) {
        let regexOwnerRole = new RegExp(OWNER_KEYWORD, 'i');
        return roles.filter(role => ((!isNullOrEmpty(role)) && (regexOwnerRole.test(role))));
    }

    return [];
};

export const getUserRoles = (roles?: string[]): string[] => {
    if ((roles !== undefined) && roles && (roles.length > 0)) {
        let regexOwnerRole = new RegExp(OWNER_KEYWORD, 'i');
        return roles.filter(role => ((!isNullOrEmpty(role)) && (!regexOwnerRole.test(role))));
    }

    return [];
};

export const hasAdminAccess = (isAuthenticated: boolean, roles: string[]): boolean => {
    if ((!isAuthenticated) || (roles === undefined) || (!roles) || (roles.length === 0)) {
        return false;
    }

    return (roles.includes(dynamicConfig.DLS_ADMIN_ROLE_NAME));
};

export const hasEditorialAccess = (isAuthenticated: boolean, roles: string[]): boolean => {
    if ((!isAuthenticated) || (roles === undefined) || (!roles) || (roles.length === 0)) {
        return false;
    }

    return ((roles.includes(dynamicConfig.DLS_EDITOR_ROLE_NAME)) || (roles.includes(dynamicConfig.DLS_ADMIN_ROLE_NAME))) as boolean;
};

export const hasPublicOnlyAccess = (isAuthenticated: boolean, roles: string[]): boolean => {
    if ((!isAuthenticated) || (roles === undefined) || (!roles) || (roles.length === 0)) {
        return true;
    }

    if ((roles.includes(dynamicConfig.DLS_EDITOR_ROLE_NAME)) || (roles.includes(dynamicConfig.DLS_USER_ROLE_NAME))) {
        return false;
    }

    return true;
};
